
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.531 17.103a5.373 5.373 0 01-.464-.27 6.526 6.526 0 01-1.193-1.014c-.89-1.018-1.222-2.05-1.344-2.773h.005c-.103-.6-.06-.989-.054-.989h-4.052v15.668c0 .21 0 .418-.009.623 0 .026-.002.05-.004.077 0 .011 0 .023-.002.035v.009a3.44 3.44 0 01-1.73 2.73 3.38 3.38 0 01-1.677.443c-1.888 0-3.418-1.54-3.418-3.44 0-1.902 1.53-3.441 3.418-3.441.357 0 .712.056 1.052.167l.005-4.126a7.527 7.527 0 00-5.8 1.697 7.95 7.95 0 00-1.734 2.14c-.171.294-.817 1.479-.895 3.402-.05 1.092.279 2.223.435 2.69v.01c.098.275.48 1.214 1.1 2.006a8.233 8.233 0 001.755 1.656v-.01l.01.01c1.961 1.333 4.136 1.245 4.136 1.245.377-.015 1.638 0 3.07-.679 1.588-.752 2.493-1.873 2.493-1.873a7.79 7.79 0 001.358-2.257c.367-.964.489-2.12.489-2.582v-8.312c.05.03.704.463.704.463s.943.604 2.414.998c1.056.28 2.478.339 2.478.339v-4.022c-.498.054-1.51-.104-2.546-.62z","fill":"#1D1D1D"}})])
          )
        }
      }
    